import { apiArtifactThemeToArtifactTheme } from "../helpers/transformers/artifact-theme";
import { videoWallConfig, VideoWallConfig } from "../mock/video-wall";
import { ArtifactTheme } from "../models/client";
import humps from "humps";
import { AboutUsPage } from "../models/client/aboutUsPage";
import { apiAboutUsPageToAboutUsPage } from "../helpers/transformers/AboutUsPage";

export const getArtifactThemes = (): Promise<ArtifactTheme[] | null> => {
  return fetch(`${process.env.REACT_APP_API_URL}/ArtifactAPI/GetArtifacts`)
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      console.log(data);
      return data;
    })
    .then((apiArtifactThemes) =>
      apiArtifactThemes.map(apiArtifactThemeToArtifactTheme)
    );
  // );
};

export const getVideoWall = (): Promise<VideoWallConfig | null> => {
  return fetch(`${process.env.REACT_APP_API_URL}/Video/GetVideos`)
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .then((videoWallConfig) => {
      return humps.camelizeKeys(videoWallConfig) as VideoWallConfig;
    });
};
export const getAboutUsPage = (): Promise<AboutUsPage | null> => {
  return fetch(`${process.env.REACT_APP_ABOUTUS_API_URL}/GetAboutUs`)
  .then((res) => {
    return res.json();
  })
  .then((data) => {
    return data;
  })
  .then((apiArtifactThemes) =>
    apiArtifactThemes.map(apiAboutUsPageToAboutUsPage)
  );
}

// export const getArtifactThemes = (): Promise<ArtifactTheme[] | null> => {
//   // return fetch("http://localhost:3004/artifactThemes")
//   return (
//     // fetch(
//     //   "http://bootsexhibition.mmbox.co.uk/API/umbraco/API/ArtifactAPI/GetArtifacts"
//     // )
//     // return (
//     new Promise<any>((resolve) => {
//       console.log(data);

//       resolve(data);
//     })
//       .then((data) => Array.from(data))

//       .then((apiArtifactThemes: any[]) => {
//         console.log(apiArtifactThemes);
//         return apiArtifactThemes.map(apiArtifactThemeToArtifactTheme);
//       })
//       .then((artifactThemes) => {
//         return delay(1000, artifactThemes);
//       })
//   );
// };

function delay<V>(t: number, v: V): Promise<V> {
  return new Promise(function (resolve) {
    setTimeout(resolve.bind(null, v), t);
  });
}
